// extracted by mini-css-extract-plugin
export default {"Wrapper":"PieChartCourseRating_Wrapper__uPhgs","CompetencesTitle":"PieChartCourseRating_CompetencesTitle__G0A6Y","ChartWrapper":"PieChartCourseRating_ChartWrapper__ISzG6"};